import { getChargePolicy } from './getChargePolicy';
import { getProductSelection } from './getProductSelection';
export const mapValuesToGiveawayConfigMutationPayload = (values) => ({
    enabled: values.enabled,
    durationSeconds: values.duration,
    productSelection: getProductSelection(values.productSelectionType, values.excludedProductsIds, values.includedProductsIds),
    chargePolicy: getChargePolicy(values.shippingChargeType, values.shippingCharge),
    platform: values.platform,
});
